import { render } from "./OtherControls.vue?vue&type=template&id=4784512c&scoped=true"
import script from "./OtherControls.vue?vue&type=script&lang=js"
export * from "./OtherControls.vue?vue&type=script&lang=js"

import "./OtherControls.vue?vue&type=style&index=0&id=4784512c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4784512c"]])

export default __exports__